/* globals lp,Class */
var inheritLastButtonStyle = require('ub/control/inherit-button-style');

var ButtonModule = Class.create(
  lp.ModuleBase,
  lp.ModuleElementMethods,
  lp.ModuleElementPropertiesPanelMethods,
  {
    beforeCreate: function(page, defaults) {
      if (page.allowExternalLightboxes()) {
        defaults.lightboxSize = lp.module.form.FormElement.lightboxSizeDefault;
      }

      defaults.action.target = page.getConfigValue('linkTargetDefault');

      inheritLastButtonStyle(page, defaults);
    }
  }
);

lp.addModule(new ButtonModule({
  type:'lp-pom-button',
  isAllowedOnPage: function(page) {
    return page.getConfigValue('allowButtonWidget');
  },
  version:'1.0',
  name: 'Button',
  usageType:'page-widget',
  namespace: lp.module.button
}));

module.exports = ButtonModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-button/button_module.js
// module id = 555
// module chunks = 0 1